import { render, staticRenderFns } from "./Compositions.vue?vue&type=template&id=52557c08&scoped=true&"
import script from "./Compositions.vue?vue&type=script&lang=js&"
export * from "./Compositions.vue?vue&type=script&lang=js&"
import style0 from "./Compositions.vue?vue&type=style&index=0&id=52557c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52557c08",
  null
  
)

export default component.exports